import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../utils/checkout';

/**
 * Sticky bottom CTA that appears once the user scrolls past the first hero CTA.
 */
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const target = document.getElementById('hero-cta');
    if (!target) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(entry.boundingClientRect.top < 0 && !entry.isIntersecting);
    }, {
      threshold: 0,
      rootMargin: '0px'
    });
    observer.observe(target);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-35" data-mp="2avb971xpodur">
      {visible ? <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-navy-800/10 bg-white/95 px-3 pb-[calc(0.6rem+env(safe-area-inset-bottom))] pt-2.5 backdrop-blur-md" data-id="element-36" data-mp="38ap6gtle64bz">
          <div className="mx-auto flex max-w-lg flex-col items-center" data-id="element-37" data-mp="2pc5uzuef7k9c">
            <a href={CHECKOUT_URL} className="animate-shake flex w-full items-center justify-center gap-2 rounded-2xl bg-aqua-500 px-4 py-3.5 text-[15px] font-extrabold uppercase tracking-wide text-white shadow-cta transition-[background-color,transform] duration-150 ease-out hover:bg-aqua-400 active:scale-[0.98] sm:text-base" data-id="element-38" data-mp="2pbw84foo9t7v">
              Get Prostho 360™ — $27
              <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-39" data-mp="26fd05tplubcw" />
            </a>
            <p className="mt-1.5 text-[11px] font-medium text-navy-800/60" data-id="element-40" data-mp="2behcuubqmr7z">
              One-time payment · Lifetime access · 7-Day Guarantee
            </p>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}